import { render, staticRenderFns } from "./compareCompanys.vue?vue&type=template&id=70af034d&scoped=true&"
import script from "./compareCompanys.vue?vue&type=script&lang=js&"
export * from "./compareCompanys.vue?vue&type=script&lang=js&"
import style0 from "./compareCompanys.vue?vue&type=style&index=0&id=70af034d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70af034d",
  null
  
)

export default component.exports